// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JMfrJ","field":"styles_field__2Ehql","fieldCol":"styles_fieldCol__eu4a-","diffCol":"styles_diffCol__3QUeK","diff":"styles_diff__wq5Dv"};